<template>
  <el-dialog
    title="视频详情信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        label="商家名称"
      >
        {{agentname}}
      </el-form-item>
      <el-form-item
              label="标题"
      >
        {{title}}
      </el-form-item>
      <el-form-item
        label="纬度"
      >
        {{latitude}}
      </el-form-item>
      <el-form-item
              label="经度"
      >
        {{longitude}}
      </el-form-item>
      <el-form-item
              label="图片/视频"
      >


        <div v-if="url!=null && url!=''">
            <span v-for="item in this.url.split(',')">

              <img :src= "getImgUrl2(item)" style="width: 200px;height: 100px; "/>


              </span>

        </div>

        <div v-if="video_url!=null && video_url!=''">

             <span v-for="(item,index) in video_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl2(item)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              </span>
          </span>




        </div>


      </el-form-item>

      <el-form-item
              label="描述"
      >
        {{describe}}
      </el-form-item>


      <el-form-item
              label="添加时间"
      >
        {{insert_times}}
      </el-form-item>

      <el-form-item
              label="是否上架"
      >

        <div v-if="state=='0' ">
          上架
        </div>
        <div v-else-if="state=='1'">
          下架
        </div>
      </el-form-item>

        <el-form-item
                label="类型"
        >
          <div v-if="type=='0'">
           图片
          </div>
          <div v-else-if="type=='1'">
           视频
          </div>
        </el-form-item>
      <el-form-item
              label="发送类型"
      >
        <div v-if="send_type=='0' ">
          全部
        </div>
        <div v-else-if="send_type=='1'">
          部分
        </div>
      </el-form-item>
      <el-form-item
              label="发送状态"
      >
        <div v-if="send_state=='0' ">
          未发送
        </div>
        <div v-else-if="send_state=='1'">
          待发送
        </div>
        <div v-else-if="send_state=='2'">
          已发送
        </div>
        <div v-else-if="send_state=='3'">
          发送中
        </div>
      </el-form-item>
        <el-form-item
                label="审核状态"
        >

          <div v-if="sh_state=='0'">
            未审核
          </div>
          <div v-else-if="sh_state=='1'">
            审核通过
          </div>
          <div v-else-if="sh_state=='2'">
            审核不通过
          </div>
        </el-form-item>
      <el-form-item
              label="审核备注"
      >
        {{sh_description}}
      </el-form-item>



    </el-form>

  </el-dialog>

</template>
<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,
      agentname:"",
      title:"",
      latitude:"",
      longitude:"",
      url:"",
      video_url:"",
      describe:"",
      insert_times:"",
      state:"",
      type:"",
      send_state:"",
      send_type:"",
      sh_state:"",
      sh_description:"",
      form: {

      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        let form = {};
        this.form = form;
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
        this.agentname=this.oneclass.agent_name;
                this.title=this.oneclass.title;
                this.latitude=this.oneclass.latitude;
                this.longitude=this.oneclass.longitude;
                this.url=this.oneclass.url;
                this.describe=this.oneclass.describe;
                this.insert_times=this.oneclass.insert_times;
                this.state=this.oneclass.state;
                this.type=this.oneclass.type;
                this.sh_state=this.oneclass.sh_state;
                this.sh_description=this.oneclass.sh_description;
                this.video_url=this.oneclass.video_url;
                this.send_state=this.oneclass.send_state;
                this.send_type=this.oneclass.send_type;






          this.formEdit = true;
      }
    },
    getImgUrl2(item){


      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+item;
    },

    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

